import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useBatchedPaginatedQuery } from './use-batched-paginated-query';
import type { BatchFetcherOpts } from './use-batched-paginated-query';

interface FeedbackListOpts {
  viewPage: number;
  viewPageSize?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  type?: string;
}

export function useFeedbackList(opts: FeedbackListOpts) {
  const viewPageSize = opts.viewPageSize ?? 10;
  return useBatchedPaginatedQuery(
    queryKeys.feedback.all(),
    (fetchOpts: BatchFetcherOpts) =>
      api.getFeedback({
        page: fetchOpts.page,
        limit: fetchOpts.limit,
        sortBy: fetchOpts.sortBy as string | undefined,
        sortOrder: fetchOpts.sortOrder as 'asc' | 'desc' | undefined,
        type: fetchOpts.type as string | undefined,
      }),
    {
      viewPage: opts.viewPage,
      viewPageSize,
      sortBy: opts.sortBy,
      sortOrder: opts.sortOrder,
      filters: { type: opts.type },
      staleTime: 1000 * 60,
    },
  );
}
